import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsNetworkMerchantSchema = withDefaults({
  type: 'pcs-network-merchant',
  fields: [
    {
      kind: 'attribute',
      name: 'network',
    },
    {
      kind: 'attribute',
      name: 'networkId',
    },
    {
      kind: 'hasMany',
      name: 'pcsMerchantNetworkMerchants',
      type: 'pcs-merchant-network-merchant',
      options: {
        async: false,
        inverse: 'pcsNetworkMerchant',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsNetworkMerchantDetails',
      type: 'pcs-network-merchant-detail',
      options: {
        async: false,
        inverse: 'pcsNetworkMerchant',
      },
    },
  ],
});

export default PcsNetworkMerchantSchema;
